import React, { useState } from 'react';

import { Button, Modal, notification } from 'antd';
import { useAppTranslation } from 'src/i18n/hooks';
import { useAcceptTerm } from 'src/services/user/accept-term';
import { useAppDispatch } from 'src/store';
import { setModalTerms } from 'src/store/actions/modal';
import ButtonContained from '../../02.buttons/ButtonContained';
import AppLabelCheckBox from '../../20.label-checkbox/indes';
import { removeAuthTokens } from 'src/helpers/storage';
import { queryClient } from 'src/libs/react-query';
import { userKeys } from 'src/services/user/user-keys';
import { useAuth } from 'src/libs/rainbow';
import { clearUserInfo } from 'src/store/actions/user';
import { useDisconnect } from 'wagmi';

interface SelectPairModalProps {
  isOpen: boolean;
  onClose?: () => void;
}

const ModalTerms: React.FC<SelectPairModalProps> = ({ isOpen, onClose }) => {
  const dispatch = useAppDispatch();
  const { t } = useAppTranslation('common');
  const [acceptTerm, setAcceptTerm] = useState(false);
  const [acceptWithdrawalTime, setAcceptWithdrawalTime] = useState(false);
  const { setAuthStatus } = useAuth();
  const { disconnectAsync } = useDisconnect();

  const userId = localStorage.getItem('userId');
  const acceptTermQuery = useAcceptTerm();

  const handleLaunch = async () => {
    dispatch(setModalTerms(false));
    await acceptTermQuery.mutateAsync(userId as string);
    notification.success({
      message: t('modalTerms.termsAcceptedMessage'),
      description: t('modalTerms.termsAcceptedDescription'),
    });
  };

  const handleDecline = async () => {
    removeAuthTokens();
    setAuthStatus('unauthenticated');
    dispatch(clearUserInfo());
    try {
      await disconnectAsync();
    } catch {}
    dispatch(setModalTerms(false));
    await queryClient.resetQueries({
      queryKey: userKeys.all,
    });
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      className="z-10 font-poppins"
      closable={false}
      centered
    >
      <div
        className={`terms-of-use text-element-primary flex flex-col gap-6 justify-center items-center`}
      >
        <div className="flex flex-col w-full md:gap-0 gap-2">
          <span className="text-xl font-semibold text-center">{t('modalTerms.title')}</span>
          <span className="text-letter-pale text-[16px] text-center">
            {t('modalTerms.subtitle')}
          </span>
        </div>

        <div className="flex flex-col gap-4 w-full">
          <AppLabelCheckBox
            onChange={(e) => {
              setAcceptTerm(e.target.checked);
            }}
            textRightPlace
            html={t('modalTerms.acceptTerms')}
            customRootClass="!font-medium w-full text-sm"
          />
          <AppLabelCheckBox
            onChange={(e) => {
              setAcceptWithdrawalTime(e.target.checked);
            }}
            textRightPlace
            html={t('modalTerms.withdrawalTerm')}
            customRootClass="!font-medium w-full text-sm"
          />
        </div>
        <div className="flex flex w-full gap-2">
          <ButtonContained onClick={handleDecline} className="flex-1" mode="v2">
            <p className="font-semibold md:text-[16px] text-sm uppercase">
              {t('modalTerms.decline')}
            </p>
          </ButtonContained>
          <ButtonContained
            disabled={!acceptTerm || !acceptWithdrawalTime}
            onClick={handleLaunch}
            className="button-confirm flex-1"
          >
            <p className="font-semibold md:text-[16px] text-sm uppercase">
              {t('modalTerms.accept')}
            </p>
          </ButtonContained>
        </div>
      </div>
    </Modal>
  );
};

export default ModalTerms;
